module.exports = __webpack_public_path__ + "assets/img/ConnectorIcon.6bb33f00.svg";